import React from 'react';

const Index = () => {
    return <div>main22</div>;
};

export default Index;
